
import ogPagesMixins from '@/mixins/ogPagesMixins'

// Настройки SEO полей head
const SEO = {
  TITLE: 'Маркетплейс - продукты | Мегасреда',
  DESCRIPTION: 'Все продукты в маркетплейсе | Мегасреда',
  H1: 'Все продукты платформы в формате маркетплейсе',
}
export default {
  mixins: [ogPagesMixins],
  props: {
    communitys: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    seoTitle() {
      return SEO.TITLE
    },
    seoDescription() {
      return SEO.DESCRIPTION
    },
    seoH1() {
      return SEO.H1
    },
  },
}
